import { axiosInstance } from './common';

export const listSensors = () =>
  axiosInstance.get('/sensors').then((r) => r.data);

export const getReadings = (sensorId, fromMs, toMs) =>
  axiosInstance
    .get(`/sensors/${sensorId}/readings`, { params: { from: fromMs, to: toMs } })
    .then((r) => r.data);
